export enum CACHE_TYPES {
  LocalStorage,
  IndexedDb,
  ServiceWorker
}

export enum REQUEST_TYPE {
  Get = 'get',
  Post = 'post',
  Delete = 'delete',
  Patch = 'patch'
}

export const DEFAULT_CACHE_CRITERIAS = {
  isCacheEnabled: true,
  expirationWindowsMS: 30000,
  cacheType: CACHE_TYPES.LocalStorage
};

export const DEFAULT_BATCH_CRITERIAS = {
  isBatchEnabled: false,
  limit: 50,
  key: ''
};

export interface CacheCriteria {
  expirationWindowsMS?: number;
  cacheType?: CACHE_TYPES;
  isCacheEnabled?: boolean;
}

export interface BatchCriteria {
  key: string;
  limit: number;
  isBatchEnabled: boolean;
}

export interface UrlConfig {
  url: string;
  method: REQUEST_TYPE;
  retryable?: boolean;
  withCredential?: boolean;
  headers?: { [key: string]: any };
  params?: { [key: string]: any };
  data?: { [key: string]: any };
}

export type ProxyCallback = (data?: object, error?: object) => void;
